
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-guides/[country]/[slug]",
      function () {
        return require("private-next-pages/travel-guides/[country]/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel-guides/[country]/[slug]"])
      });
    }
  